var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFacebookİcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.7314 28 28 21.7314 28 14C28 6.26855 21.7314 0 14 0C6.26855 0 0 6.26855 0 14C0 21.7314 6.26855 28 14 28ZM17.4043 12.6191L17.0409 15.0072H15.1348V20.7835C14.7178 20.8496 14.2905 20.8838 13.8564 20.8838C13.4212 20.8838 12.9951 20.8496 12.5781 20.7835V15.0072H10.5V12.6191H12.5781V10.7985C12.5781 8.72721 13.7983 7.58333 15.668 7.58333C16.5635 7.58333 17.5 7.74512 17.5 7.74512V9.77767H16.4678C15.7728 9.77767 15.4048 10.0762 15.2419 10.4727C15.1667 10.6572 15.1348 10.8623 15.1348 11.0697V12.6191H17.4043Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFacebookİcon);
export default __webpack_public_path__ + "static/media/mobile-facebook-icon.45b79ffc47244fa43010f2641b0c1085.svg";
export { ForwardRef as ReactComponent };